'use strict';
class DdjjProddetalleobsModalController {
  constructor($uibModalInstance, data, $sce, $log, DataService, $state, $location) {
    'ngInject';
    this.data = data;
    this.$uibModalInstance = $uibModalInstance;
    this.$sce = $sce;
    this.$log = $log;
    this.DataService = DataService;
    this.$state = $state;
    this.$location = $location;
  }

  $onInit() {
  }

  ok() {
    var obj = {
      idCertificacion: this.data.id_certificacion,
      idProducto: this.data.id_producto,
      motivo: this.observacion
    };
    
    var ruta = 'certificacionesSHB/cambiar';
    this.DataService.put(ruta, obj)
      .then(response => {
        if (response) {
          this.$uibModalInstance.close();
          this.$log.log('Respuesta***= ', response);
          this.$location.path('declaracionesJuradasPromueve');
        }
      });
    this.$uibModalInstance.close();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default DdjjProddetalleobsModalController;


// WEBPACK FOOTER //
// ./src/app/components/admin/promueve/certificacion/modal_input/changeTipo.modal.controller.js